<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      采购单管理
    </p>
    <template slot="extra">
      <Button type="primary" icon="md-add" @click="addOpen()" v-access="'orderList.add'">添加</Button>
    </template>
    <Row>
      <Col span="24">
        <Input
          v-model="query.orderId"
          placeholder="请输入采购单号"
          class="public-inp md5"
        />
        <Input
          v-model="query.spOrderId"
          placeholder="请输入品牌商单号"
          class="public-inp md5"
        />
        <Select
          v-model="query.status"
          placeholder="请选择状态"
          class="public-inp md5"
        >
          <Option value="">全部</Option>
          <Option value="1">待审核</Option>
          <Option value="10">审核不通过</Option>
          <Option value="20">审核通过</Option>
        </Select>
        <span class="public-stretch" @click="open = !open">
          <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" />{{
            open ? "收起" : "展开"
          }}
        </span>
        <span v-if="open">
          <br />
          <Select
            v-model="query.spCode"
            placeholder="请选择资金商"
            class="public-inp"
          >
            <Option
              v-for="(item, index) in spList"
              :key="index"
              :value="item.code"
              >{{ item.name }}</Option
            >
          </Select>
          <Select
            v-model="query.wmsCode"
            placeholder="请选择仓库"
            class="public-inp"
          >
            <Option
              v-for="(option, index) in wmsCodeList"
              :value="option.wmsCode"
              :key="index"
              >{{ option.wmsName }}</Option
            >
          </Select>
          <DatePicker
            type="daterange"
            :options="options"
            placement="bottom-start"
            placeholder="请选择采购时间"
            v-model="seTime"
            class="public-inp"
          ></DatePicker>
        </span>
        <Button class="public-fr" @click="reset()" v-access="'orderList.reset'"> 重置</Button>
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'orderList.query'"
          >查询</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ (page - 1) * pageSize + index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <!-- 状态 : 1:待审核 10：审核不通过 20: 审核通过 -->
            <div v-show="row.status == 1">
              <a href="javascript:;" @click="detailOpen(row,1)" v-access="'orderList.edit'">审核</a>
              <a href="javascript:;" @click="detailOpen(row)" v-access="'orderList.details'">查看</a>
            </div>
            <div v-show="row.status == 10 || row.status == 20">
              <a href="javascript:;" @click="detailOpen(row)" v-access="'orderList.details'">查看</a>
            </div>
          </template>
        </Table>
        <Page
          :total="total"
          :page-size="pageSize"
          :current="page"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class="public-page"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "制单人账号名",
    key: "createOperatorName",
  },
  {
    title: "采购单号",
    key: "orderId",
  },
  {
    title: "采购日期",
    key: "purchaseTime",
    width: 150,
  },
  {
    title: "品牌商单号",
    key: "spOrderId",
    width: 150,
  },

  {
    title: "资金商",
    key: "spName",
  },
  {
    title: "仓库",
    key: "wmsName",
  },
  {
    title: "状态",
    key: "status",
    render: (h, params) => {
      let s = params.row.status;
      let t = s == 20 ? "审核通过" : s == 10 ? "审核不通过" : "待审核";
      return h("span", t);
    },
  },
  {
    title: "备注",
    key: "remark",
  },
  {
    title: "操作",
    slot: "action",
  },
];
const options = {
  shortcuts: [
    {
      text: "1 week",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      },
    },
    {
      text: "1 month",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      },
    },
    {
      text: "3 months",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        return [start, end];
      },
    },
  ],
};
export default {
  data() {
    return {
      open: false,
      options,
      seTime: [],
      query: {
        orderId: "",
        spCode: "",
        spOrderId: "",
        status: "",
        wmsCode: "",
      },
      page: 1,
      pageSize: 10,
      total: 0,
      columns,
      tbList: [],
      loading: false,
      spList: [],
      wmsCodeList: [],
    };
  },
  created() {
    this.getOption();
    this.getList();
  },
  methods: {
    getOption() {
      this.$api["spSearchAll"]({}).then((res) => {
        if (res.code == "200") {
          this.spList = res.data;
        }
      });
      this.$api.wareSearch({ pageSize: 9999 }).then((res) => {
        if (res.code == "200") {
          this.wmsCodeList = res.data;
        }
      });
    },
    getList() {
      let data = {
        ...this.query,
        purchaseTimeStart: this.initTime(this.seTime, 0),
        purchaseTimeEnd: this.initTime(this.seTime, 1),
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$api["purchSearch"](data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    initTime(t, i) {
      if (!t[i]) {
        return "";
      }
      let d = t[i];
      let str = new Date(d);
      return this.tools.formatDate(str);
    },
    reset() {
      Object.keys(this.query).forEach((key) => {
        this.query[key] = "";
      });
      this.seTime = [];
      this.page = 1;
      this.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    addOpen(d) {
      this.$router.replace({
        path: "/orderAdd",
        query: { orderId: d ? d.orderId : "" },
      });
    },
    detailOpen(d,i) {
      this.$router.replace({
        path: "/orderDetail",
        query: { orderId: d ? d.orderId : "",showStatus:i?1:''},
      });
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/warehouse/orderList.vue